<div class="outerLoadingContainer">
  <div class="loadingContainer">
    <div class="marker"></div>
    <div class="marker" style="animation-delay: 0.05s"></div>
    <div class="marker" style="animation-delay: 0.1s"></div>
  </div>
</div>
